import { useState } from "react";
import { useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import Select from 'react-select';
import moment from 'moment';
import { getSubscriptionChargesByDateAndSubID, getSubscriptionMasterByMembershipType, getSubscriptionValidityForAdmin, postOfflineSubscription } from "../api/paymentAPI";

const UpdateMembershipModal = (props) => {

    const {membershipRecord, setMembershipRecord, from, membershipValidity, userDetails, refetchMembership, vIndex, allowEditStartDate} = props;

    const [membershipValidityDetails, setMembershipValidityDetails]     = useState({});
    const [membershipPlanOption,      setMembershipPlanOption]          = useState([]);
    const [planID,                    setPlanID]                        = useState();

    useEffect(() => {
        $('#add-update-membership-modal').modal({
            backdrop: 'static',
        });
        $('#add-update-membership-modal').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            $(from).removeClass('modal-blur');
            props.onDismissModal(false);
        });
        $(from).addClass('modal-blur');
        $('#txtMembershipStartsFrom').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });
        $('#txtMembershipStartsFrom').on('change', function (event) {
            updateMembershipDetails('SubscriptionStartsFrom',  moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        });
        $('#txtMembershipExpiresOnModal').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });
        $('#txtMembershipExpiresOnModal').on('change', function (event) {
            const formatted = moment(event.target.value, 'DD-MM-YYYY').format('YYYY-MM-DD');
            if (!formatted.startsWith('9999')) {
                updateMembershipDetails('SubscriptionExpiresOn', formatted);
            }
        });
    }, []);

    useEffect(() => {
        if (userDetails.MembershipType) {
            if (from == "#edit-user-modal") {
                fetchMembershipPlans(userDetails.MembershipType);
            } else {
                fetchMembershipPlans(userDetails.MembershipType);
                setMembershipValidityDetails(membershipValidity);
            }

        };
      }, [userDetails.MembershipType]);

    useEffect(() => {
        if (planID && !membershipValidityDetails?.OrderID) {
            fetchMembershipChargesByDateAndPlanID(planID);
        };
      }, [planID]);

    useEffect(() => {
        if (Object.keys(membershipRecord).length > 0) {
            if(from == "#edit-user-modal"){
                setMembershipValidityDetails(membershipRecord);
            }else{
                setMembershipValidityDetails(membershipRecord)
            }
        };
      }, [membershipRecord]);

    // warn immediately when expiry date on an active membership would overlap an upcoming one
    useEffect(() => {
        const newExpiry = membershipValidityDetails?.SubscriptionExpiresOn;
        if (!newExpiry || membershipValidityDetails?.Status !== 'Active') return;

        const conflict = membershipValidity.find(s =>
            s.Status === 'Upcoming' &&
            s.OrderID !== membershipValidityDetails?.OrderID &&
            moment(newExpiry).isBetween(s.SubscriptionStartsFrom, s.SubscriptionExpiresOn, undefined, '[]')
        );
        if (conflict) {
            swal.fire({
                icon              : 'warning',
                titleText         : 'Date Conflict!',
                text              : `Expiry date overlaps with an upcoming membership starting ${moment(conflict.SubscriptionStartsFrom).format('DD-MMM-YYYY')}`,
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand',
            });
        }
    }, [membershipValidityDetails?.SubscriptionExpiresOn]);

    // warn immediately when an upcoming membership's dates conflict with any Active or Upcoming membership
    useEffect(() => {
        const newStart  = membershipValidityDetails?.SubscriptionStartsFrom;
        const newExpiry = membershipValidityDetails?.SubscriptionExpiresOn;
        if (!newStart || !newExpiry || membershipValidityDetails?.Status !== 'Upcoming') return;

        const conflict = membershipValidity.find(s =>
            s.OrderID !== membershipValidityDetails?.OrderID &&
            (s.Status === 'Active' || s.Status === 'Upcoming') &&
            (
                moment(newStart).isBetween(s.SubscriptionStartsFrom, s.SubscriptionExpiresOn, undefined, '[]') ||
                moment(newExpiry).isBetween(s.SubscriptionStartsFrom, s.SubscriptionExpiresOn, undefined, '[]') ||
                (moment(newStart).isBefore(s.SubscriptionStartsFrom) && moment(newExpiry).isAfter(s.SubscriptionExpiresOn))
            )
        );
        if (conflict) {
            swal.fire({
                icon              : 'warning',
                titleText         : 'Date Conflict!',
                text              : `Dates overlap with an ${conflict.Status.toLowerCase()} membership (${moment(conflict.SubscriptionStartsFrom).format('DD-MMM-YYYY')} to ${moment(conflict.SubscriptionExpiresOn).format('DD-MMM-YYYY')})`,
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand',
            });
        }
    }, [membershipValidityDetails?.SubscriptionStartsFrom, membershipValidityDetails?.SubscriptionExpiresOn]);

    // auto-compute end date from start date + plan duration
    useEffect(() => {
        const start    = membershipValidityDetails?.SubscriptionStartsFrom;
        const months   = membershipValidityDetails?._ValidityMonths;
        const lifetime = membershipValidityDetails?._IsLifetime;

        if (!start || !months || lifetime === 'Y') return;

        const endDate = moment(start).add(months, 'months').subtract(1, 'day').format('YYYY-MM-DD');
        updateMembershipDetails('SubscriptionExpiresOn', endDate);
        $('#txtMembershipExpiresOnModal').val(moment(endDate).format('DD-MM-YYYY'));
    }, [membershipValidityDetails?.SubscriptionStartsFrom, membershipValidityDetails?._ValidityMonths]);

    // new logic for proper calculation
    useEffect(() => {
        // Charge is Subscription Charge
        const { SubscriptionCharge, GST, MembershipFee } = membershipValidityDetails;
        if (SubscriptionCharge !== undefined && GST !== undefined && MembershipFee !== undefined) {
            const charge = parseFloat(SubscriptionCharge) || 0;
            const gst    = parseFloat(GST) || 0;
            const membershipFee = parseFloat(MembershipFee) || 0;

            const baseAmount = membershipFee + charge; // excluding GST
            const GSTAmount = Math.round((baseAmount * gst) / 100);
            const Total = Math.round(baseAmount + GSTAmount);

            setMembershipValidityDetails(prev => ({
                ...prev,
                GSTAmount,
                Total
            }));
        }
    }, [membershipValidityDetails?.SubscriptionCharge, membershipValidityDetails?.GST, membershipValidityDetails?.MembershipFee]);

    const fetchMembershipPlans = async(membershipType) =>{
        try {
            const response = await getSubscriptionMasterByMembershipType(membershipType)
            setMembershipPlanOption(response);
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })
        }
    };

    const fetchMembershipChargesByDateAndPlanID = async(id) =>{
        try {
            const response = await getSubscriptionChargesByDateAndSubID(id)
            if(Object.keys(response).length > 0){
                setMembershipValidityDetails(prev => ({...prev, ...response, GSTAmount: response?.GSTAmount?.replace(/,/g, ""), Total: response?.Total?.replace(/,/g, "")}));
            }
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })
        }
    };

    const saveMembershipHandler = async(e) => {
        e.preventDefault()

        const btn = $('#btnSave');
        var form = $('#add-membership-form');

        form.validate({
            rules: {
                ddlMembershipPlan: {
                    required: true
                },
                txtMembershipStartsFrom: {
                    required: true,
                },
                txtMembershipExpiresOnModal: {
                    required: !(membershipValidityDetails.SubscriptionExpiresOn?.startsWith('9999')),
                },
                txtCharge: {
                    required: true
                },
                txtGST: {
                    required: true
                },
                txtMembershipFee: {
                    required: true
                }
            },
            messages: {
                ddlMembershipPlan: {
                    required: "Please select membership plan"
                },
                txtMembershipStartsFrom: {
                    required: "Please select membership starts from"
                },
                txtMembershipExpiresOnModal: {
                    required: "Please select membership expires On"
                },
                txtCharge: {
                    required: "Please enter charge"
                },
                txtGST: {
                    required: "Please enter gst"
                },
                txtMembershipFee: {
                    required: "Please enter Membership Fee"
                }
            }
        });

        if (!form.valid()) return;
        if((moment(membershipValidityDetails.SubscriptionStartsFrom).isAfter(membershipValidityDetails.SubscriptionExpiresOn)) || membershipValidity.find((d) => d.OrderID !== membershipValidityDetails.OrderID && (moment(membershipValidityDetails.SubscriptionStartsFrom) < moment(d.SubscriptionStartsFrom) && moment(membershipValidityDetails.SubscriptionExpiresOn) > moment(d.SubscriptionExpiresOn)  || moment(membershipValidityDetails.SubscriptionStartsFrom).isBetween(d.SubscriptionStartsFrom, d.SubscriptionExpiresOn) || moment(membershipValidityDetails.SubscriptionExpiresOn).isBetween(d.SubscriptionStartsFrom, d.SubscriptionExpiresOn) || moment(membershipValidityDetails.SubscriptionStartsFrom).isSame(d.SubscriptionStartsFrom) || moment(d.SubscriptionStartsFrom).isSame(membershipValidityDetails.SubscriptionExpiresOn) || moment(membershipValidityDetails.SubscriptionExpiresOn).isSame(d.SubscriptionExpiresOn) || moment(d.SubscriptionExpiresOn ).isSame(membershipValidityDetails.SubscriptionStartsFrom)))){
            swal.fire({
                icon                  : 'warning',
                titleText             : 'Date Conflict!',
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            helper.StopProcessing(btn);
            return
        };
        helper.StartProcessing(btn);

        try {
            console.log('membershipValidityDetails', membershipRecord.OrderID );
            console.log('|| vIndex',   vIndex);
            const subDetails = {
                OrderID:                   membershipValidityDetails?.OrderID,
                UserID:                    userDetails.ID,
                SubscriptionID:            membershipValidityDetails.SubscriptionID,
                MembershipFee :            membershipValidityDetails.MembershipFee,
                Total:                     membershipValidityDetails.Total,
                GST:                       membershipValidityDetails.GST,
                GSTAmount:                 membershipValidityDetails.GSTAmount,
                SubscriptionCharge:        membershipValidityDetails.SubscriptionCharge,
                Comment:                   membershipValidityDetails?.Comment || '',
                GroupID:                   userDetails.GroupID,
                SubscriptionStartsFrom:    membershipValidityDetails.SubscriptionStartsFrom,
                SubscriptionExpiresOn:     membershipValidityDetails.SubscriptionExpiresOn
            };

            helper.StopProcessing(btn);
            $('#add-update-membership-modal').modal('hide');

            if(from == "#edit-user-modal"){
                await postOfflineSubscription(subDetails)
                $('#edit-user-modal').removeClass('modal-blur');
                refetchMembership()

            }else{
                const currentDate = new Date().toISOString()
                setMembershipRecord({
                    ...subDetails,
                    ...membershipPlanOption.filter(f => f.ID == subDetails.SubscriptionID)[0] ,
                    Status:
                        subDetails.SubscriptionStartsFrom <= currentDate && currentDate <= subDetails.SubscriptionExpiresOn
                        ? "Active"
                        : "Upcoming",
                    OrderID:  from != "Onboarding" ? (membershipRecord.OrderID || vIndex) : ''});
            };

            if (membershipValidityDetails.ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Membership updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20',
                    },
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Membership added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return
        }

        setMembershipValidityDetails({});

        form.clearForm();
        form.validate().resetForm();
    };

    const updateMembershipDetails = (field, value) => {
        if(field == 'SubscriptionID') setPlanID(value);
        setMembershipValidityDetails((d) => {
            return { ...d, [field]: value };
        });
    };

    const closeModal = () =>{
        setMembershipRecord({});
    };

    return(
        <>
            <div className="modal fade" id="add-update-membership-modal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Membership</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={closeModal}
                            >
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="kt-form" id="add-membership-form">
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                    <div className="row">
                                        <div className="col-4 form-group" >
                                            <label>Membership Plan</label>
                                            <Select
                                                id="ddlMembershipPlan"
                                                name="ddlMembershipPlan"
                                                className="multi-custom"
                                                placeholder="Select Membership Plan"
                                                isDisabled = {membershipValidityDetails?.OrderID }
                                                value={(membershipPlanOption && membershipPlanOption.length > 0 && membershipValidityDetails.SubscriptionID) && {label: membershipPlanOption.find((m) => m.ID == membershipValidityDetails.SubscriptionID).Name, value: membershipValidityDetails.SubscriptionID} || ''}
                                                onChange={(event) => {
                                                    updateMembershipDetails('SubscriptionID', event.value);
                                                    const plan = membershipPlanOption.find(p => p.ID === event.value);
                                                    updateMembershipDetails('_ValidityMonths', plan?.ValidityMonths ?? null);
                                                    updateMembershipDetails('_IsLifetime',     plan?.IsLifetime    ?? 'N');
                                                }}
                                                options={membershipPlanOption.map(m => ({
                                                    label: m.Name,
                                                    value: m.ID
                                                }))}
                                            />
                                        </div>
                                        <div className="col-4 form-group">
                                            <label>Membership Starts From</label>
                                            <div className="input-group date">
                                                <input
                                                    id="txtMembershipStartsFrom"
                                                    name="txtMembershipStartsFrom"
                                                    type="text"
                                                    placeholder="Select starts from"
                                                    className="form-control date-input"
                                                    disabled = {membershipValidityDetails?.OrderID && !allowEditStartDate ? 'disabled' : '' }
                                                    readOnly={true}
                                                    value={membershipValidityDetails.SubscriptionStartsFrom ? moment(membershipValidityDetails.SubscriptionStartsFrom).format('DD-MM-YYYY') : ''}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="la la-calendar-check-o"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-4 form-group">
                                            <label>Membership Expires On</label>
                                            <div className="input-group date">
                                                <input
                                                    id="txtMembershipExpiresOnModal"
                                                    name="txtMembershipExpiresOnModal"
                                                    type="text"
                                                    placeholder="Select expires on"
                                                    className="form-control date-input"
                                                    readOnly={true}
                                                    disabled={membershipValidityDetails.SubscriptionExpiresOn?.startsWith('9999') ? 'disabled' : ''}
                                                    value={membershipValidityDetails.SubscriptionExpiresOn && membershipValidityDetails.SubscriptionExpiresOn.startsWith('9999') ? 'Lifetime' : membershipValidityDetails.SubscriptionExpiresOn ? moment(membershipValidityDetails.SubscriptionExpiresOn).format('DD-MM-YYYY') : ''}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        <i className="la la-calendar-check-o"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>Membership Fee</label>
                                            <input
                                                id="txtMembershipFee"
                                                name="txtMembershipFee"
                                                type="number"
                                                className="form-control"
                                                disabled = {membershipValidityDetails?.OrderID ? 'disabled' : '' }
                                                value={membershipValidityDetails.MembershipFee ?? ''}
                                                onChange={(event) => updateMembershipDetails('MembershipFee', event.target.value)}
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>GST %</label>
                                            <input
                                                id="txtGST"
                                                name="txtGST"
                                                type="number"
                                                className="form-control"
                                                disabled = {membershipValidityDetails?.OrderID ? 'disabled' : '' }
                                                value={membershipValidityDetails.GST ?? ''}
                                                onChange={(event) => updateMembershipDetails('GST', event.target.value)}
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>GST Amount</label>
                                            <input
                                                id="txtGSTAmount"
                                                name="txtGSTAmount"
                                                type="number"
                                                className="form-control"
                                                value={membershipValidityDetails.GSTAmount ?? ''}
                                                disabled
                                            />
                                        </div>
                                        <div className="col form-group" style={{marginBottom: '1rem'}}>
                                            <label>Total</label>
                                            <input
                                                id="txtTotal"
                                                name="txtTotal"
                                                type="number"
                                                className="form-control"
                                                value={membershipValidityDetails.Total ?? ''}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12 form-group">
                                            <label>Remark</label>
                                            <textarea
                                                id="txtComment"
                                                name="txtComment"
                                                className="form-control"
                                                rows="3"
                                                value={membershipValidityDetails.Comment || ''}
                                                onChange={(event) => updateMembershipDetails('Comment', event.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary margin-0 margin-r5"
                                data-dismiss="modal"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                            <button
                                id="btnSave"
                                onClick={saveMembershipHandler}
                                type="button"
                                className={`btn btn-brand margin-0 `}
                            >
                                {membershipRecord?.OrderID ? 'Update Membership' : 'Add Membership'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateMembershipModal;
